module.exports = __webpack_public_path__ + "img/report.9a112a9c.png";